export const Complete = () => {
  return (
    <div className="text-center my-12">
      お申込とユーザー登録に成功しました！ご登録いただいたメールアドレスへご本人確認メールをお送りしました。
      <br />
      本人確認後、ログインページよりログインし、料金のお支払いをお願いします。お支払い確認後、退職届の送付手続きを開始します。
    </div>
  );
};
